// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function MapPinBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 7.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 8a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-14A11.512 11.512 0 0 0 4.5 13c0 9.67 10.205 16.925 10.64 17.229a1.5 1.5 0 0 0 1.72 0 32.382 32.382 0 0 0 5.273-4.875C25.642 21.32 27.5 17.046 27.5 13A11.513 11.513 0 0 0 16 1.5Zm3.913 21.839A31.164 31.164 0 0 1 16 27.11a31.164 31.164 0 0 1-3.912-3.772C10 20.92 7.5 17.164 7.5 13a8.5 8.5 0 0 1 17 0c0 4.164-2.5 7.921-4.587 10.339Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
